import { useEffect } from 'react'

type EventListenerHookType = {
  eventName: string
  handler: (e: CustomEvent) => void
}

export const useEventListenerHook = ({
  eventName,
  handler
}: EventListenerHookType): void => {
  useEffect(() => {
    document.addEventListener(eventName, handler)
    return () => {
      document.removeEventListener(eventName, handler)
    }
  }, [])
}
